var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixMediaSiteMediaV1FileDescriptor from '@wix/ambassador-media-site-media-v1-file-descriptor/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var MediaType;
(function (MediaType) {
    MediaType["UNKNOWN"] = "UNKNOWN";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["AUDIO"] = "AUDIO";
    MediaType["DOCUMENT"] = "DOCUMENT";
    MediaType["VECTOR"] = "VECTOR";
    MediaType["ARCHIVE"] = "ARCHIVE";
    MediaType["MODEL3D"] = "MODEL3D";
    MediaType["OTHER"] = "OTHER";
})(MediaType || (MediaType = {}));
export var OperationStatus;
(function (OperationStatus) {
    /** File upload or processing failed */
    OperationStatus["FAILED"] = "FAILED";
    /** File is ready for consumption */
    OperationStatus["READY"] = "READY";
    /** File is waiting for processing or currently being processed */
    OperationStatus["PENDING"] = "PENDING";
})(OperationStatus || (OperationStatus = {}));
export var State;
(function (State) {
    /** File is ready for consumption */
    State["OK"] = "OK";
    /** Deleted file */
    State["DELETED"] = "DELETED";
})(State || (State = {}));
export var Namespace;
(function (Namespace) {
    Namespace["NO_NAMESPACE"] = "NO_NAMESPACE";
    Namespace["OTHERS"] = "OTHERS";
    /** ANY = 2; */
    Namespace["WIX_VIDEO"] = "WIX_VIDEO";
    /** _nsWixMusic */
    Namespace["WIX_MUSIC"] = "WIX_MUSIC";
    /** _nsArtStore */
    Namespace["ALBUMS_AND_ART_STORE"] = "ALBUMS_AND_ART_STORE";
    /** _nsDigitalProduct */
    Namespace["WIX_ECOM"] = "WIX_ECOM";
    /** _nsPhotoShareApp */
    Namespace["PHOTO_SHARE_APP"] = "PHOTO_SHARE_APP";
    /** _nsSharingApp, */
    Namespace["SHARING_APP"] = "SHARING_APP";
    /** engage */
    Namespace["CHAT"] = "CHAT";
    /** logobuilder */
    Namespace["LOGO_BUILDER"] = "LOGO_BUILDER";
    /** WixExposure */
    Namespace["ALBUMS_OLD"] = "ALBUMS_OLD";
    /** chat-mobile-uploads */
    Namespace["CHAT_MOBILE"] = "CHAT_MOBILE";
    /** _nsWixForms */
    Namespace["WIX_FORMS"] = "WIX_FORMS";
})(Namespace || (Namespace = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["WIX_USER"] = "WIX_USER";
    IdentityType["APP"] = "APP";
})(IdentityType || (IdentityType = {}));
export var ContentDisposition;
(function (ContentDisposition) {
    /** Using the link in the browser will download the file */
    ContentDisposition["ATTACHMENT"] = "ATTACHMENT";
    /** Using the link in the browser will open the file in the browser */
    ContentDisposition["INLINE"] = "INLINE";
})(ContentDisposition || (ContentDisposition = {}));
export var UploadProtocol;
(function (UploadProtocol) {
    /** The upload protocol to use for implementing the resumable upload. */
    UploadProtocol["TUS"] = "TUS";
})(UploadProtocol || (UploadProtocol = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var RootFolder;
(function (RootFolder) {
    /** Root of all site media */
    RootFolder["MEDIA_ROOT"] = "MEDIA_ROOT";
    /** Root of the trash system folder */
    RootFolder["TRASH_ROOT"] = "TRASH_ROOT";
    /** Root of all visitor uploads */
    RootFolder["VISITOR_UPLOADS_ROOT"] = "VISITOR_UPLOADS_ROOT";
})(RootFolder || (RootFolder = {}));
export var StreamFormat;
(function (StreamFormat) {
    StreamFormat["UNKNOWN"] = "UNKNOWN";
    StreamFormat["HLS"] = "HLS";
    StreamFormat["DASH"] = "DASH";
})(StreamFormat || (StreamFormat = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _audioV2 = { assets: 'wix.common.Audio' };
const _bulkDeleteFilesRequest = {};
const _bulkDeleteFilesResponse = {};
const _bulkImportFileRequest = { importFileRequests: '_importFileRequest' };
const _bulkImportFileResponse = { results: '_bulkImportFileResult' };
const _bulkImportFileResult = { item: '_fileDescriptor' };
const _bulkImportFilesRequest = { importFileRequests: '_importFileRequest' };
const _bulkImportFilesResponse = { files: '_fileDescriptor' };
const _bulkRestoreFilesFromTrashBinRequest = {};
const _bulkRestoreFilesFromTrashBinResponse = {};
const _fileDescriptor = { media: '_fileMedia' };
const _fileMedia = {
    video: 'wix.common.VideoV2',
    document: 'wix.common.Document',
    image: '_imageMedia',
    audio: '_audioV2',
    vector: '_imageMedia',
    model3d: '_model3D',
};
const _generateFileDownloadUrlRequest = {};
const _generateFileDownloadUrlResponse = {};
const _generateFileResumableUploadUrlRequest = {};
const _generateFileResumableUploadUrlResponse = {};
const _generateFilesDownloadUrlRequest = {};
const _generateFilesDownloadUrlResponse = {};
const _generateFileUploadUrlRequest = {};
const _generateFileUploadUrlResponse = {};
const _generateVideoStreamingUrlRequest = {};
const _generateVideoStreamingUrlResponse = {};
const _generateWebSocketTokenRequest = {};
const _generateWebSocketTokenResponse = {};
const _getFileDescriptorRequest = {};
const _getFileDescriptorResponse = { file: '_fileDescriptor' };
const _getFileDescriptorsRequest = {};
const _getFileDescriptorsResponse = { files: '_fileDescriptor' };
const _imageMedia = {
    image: 'wix.common.Image',
    previewImage: 'wix.common.Image',
};
const _importFileRequest = {};
const _importFileResponse = { file: '_fileDescriptor' };
const _listDeletedFilesRequest = {};
const _listDeletedFilesResponse = { files: '_fileDescriptor' };
const _listFilesRequest = {};
const _listFilesResponse = { files: '_fileDescriptor' };
const _model3D = { thumbnail: 'wix.common.Image' };
const _searchFilesRequest = {};
const _searchFilesResponse = { files: '_fileDescriptor' };
const _updateFileDescriptorRequest = { file: '_fileDescriptor' };
const _updateFileDescriptorResponse = { file: '_fileDescriptor' };
const _updateFileRequest = {};
const _updateFileResponse = { file: '_fileDescriptor' };
/**
 * Generates a URL for downloading a compressed file containing specific files in the Media Manager.
 *
 * The `generateFilesDownloadUrl()` function returns a Promise that resolves to a download URL.
 *
 * The compressed file can contain up to 1000 files.
 *
 * To generate one or more temporary URLs for downloading a specific file in the Media Manager, use the `generateFileDownloadUrl()` function.
 * You can use the `expirationInMinutes` parameter to set the URL expiration time, making it more secure than the `generateFilesDownloadUrl()` function.
 * Therefore, to download private files, use the `generateFileDownloadUrl` function for each private file that you want to generate a download URL for.
 * @public
 * @requiredField fileIds
 * @param fileIds - IDs of the files to download.
 *
 * You can also pass the files' Wix media URLs. For example, `["wix:image://v1/0abec0_b291a9349a0b4da59067f76287e386fb~mv2.jpg/leon.jpg#originWidth=3024&originHeight=4032"]`.
 * Learn more in the File and Folder IDs article.
 * @adminMethod
 */
export function generateFilesDownloadUrl(fileIds) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fileIds: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateFilesDownloadUrlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateFilesDownloadUrlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fileIds]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.generateFilesDownloadUrl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fileIds',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Generates one or more temporary URLs for downloading a specific file in the Media Manager.
 *
 * The `generateFileDownloadUrl()` function returns a Promise that resolves to an array containing download URLs for the assets specified in the options parameter.
 *
 * To download different assets of the file, use the `assetKeys` parameter which generates a download URL for each asset.
 * If no asset key is specified, it defaults to `src`, which generates one download URL in the original file's format and quality.
 *
 * Use this function to grant external clients access to a private media file. Use the `expirationInMinutes` parameter to set the URL expiration time, and the `expirationRedirectUrl` parameter to add a redirect URL when the URL expires.
 *
 * To generate a permanent URL for downloading a compressed file that contains multiple files in the Media Manager, use the `generateFilesDownloadUrl()` function.
 * Since this is a permanent URL, it is less secure. Therefore, to download private files, use the `generateFileDownloadUrl()` function for each private file that you want to generate a download URL for.
 * @public
 * @requiredField fileId
 * @param options - Options to use when generating a file's download URL.
 * @param fileId - File ID.
 *
 * You can also pass the files' Wix media URLs. For example, `["wix:image://v1/0abec0_b291a9349a0b4da59067f76287e386fb~mv2.jpg/leon.jpg#originWidth=3024&originHeight=4032"]`.
 * Learn more in the File and Folder IDs article.
 * @adminMethod
 */
export function generateFileDownloadUrl(fileId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            fileId: '$[0]',
            downloadFileName: '$[1].downloadFileName',
            expirationInMinutes: '$[1].expirationInMinutes',
            expirationRedirectUrl: '$[1].expirationRedirectUrl',
            assetKeys: '$[1].assetKeys',
            contentDisposition: '$[1].contentDisposition',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateFileDownloadUrlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateFileDownloadUrlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fileId, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.generateFileDownloadUrl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fileId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Gets information about the specified file in the Media Manager.
 *
 *
 * The `getFileDescriptor()` function returns a Promise that resolves to the specified file's descriptor.
 *
 * Use `getFileDescriptors()` to get multiple file descriptors at once.
 * @public
 * @requiredField fileId
 * @param fileId - File ID.
 *
 * You can also pass the files' Wix media URLs. For example, `["wix:image://v1/0abec0_b291a9349a0b4da59067f76287e386fb~mv2.jpg/leon.jpg#originWidth=3024&originHeight=4032"]`.
 * Learn more in the File and Folder IDs article.
 * @adminMethod
 * @returns Information about the file.
 */
export function getFileDescriptor(fileId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fileId: '$[0]' };
        const responseTransformation = '$.file';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getFileDescriptorRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getFileDescriptorResponse,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['file']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fileId]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.getFileDescriptor(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fileId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Gets information about the specified files in the Media Manager.
 *
 *
 * The `getFileDescriptors()` function returns a Promise that resolves to an array containing the specified files' descriptors.
 *
 * Use `getFileDescriptor()` to get a single file descriptor.
 * @public
 * @requiredField fileIds
 * @param fileIds - File IDs.
 *
 * You can also pass the files' Wix media URLs. For example, `["wix:image://v1/0abec0_b291a9349a0b4da59067f76287e386fb~mv2.jpg/leon.jpg#originWidth=3024&originHeight=4032"]`.
 * Learn more in the File and Folder IDs article.
 * @adminMethod
 */
export function getFileDescriptors(fileIds) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fileIds: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getFileDescriptorsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getFileDescriptorsResponse,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['Array#files']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fileIds]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.getFileDescriptors(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fileIds',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a file.
 *
 *
 * The `updateFileDescriptor()` function returns a Promise that resolves to the updated file's descriptor.
 *
 * You can use the `parentFolderId` parameter to move a file from its current folder to a different folder.
 * @param _id - File ID. Generated when a file is uploaded to the Media Manager.
 * @public
 * @requiredField _id
 * @requiredField options.file
 * @adminMethod
 * @returns Information about the updated file.
 */
export function updateFileDescriptor(_id, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            file: { '*': '$[1].file', id: '$[0]' },
            fieldMask: '$[1].fieldMask',
        };
        const responseTransformation = '$.file';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateFileDescriptorRequest,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['file']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateFileDescriptorResponse,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['file']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.updateFileDescriptor(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Generates an upload URL to allow external clients to upload a file to the Media Manager.
 *
 * The `generateFileUploadUrl()` function returns a Promise that resolves to an upload URL.
 *
 * To learn how external clients can use the generated upload URL in the response to upload a file to the Media Manager, see the Upload API article.
 *
 * > **Notes:**
 * > - When you upload a file, it's not immediately available, meaning you can't manage or use the file straight away. Learn more about [knowing when a file is ready](/files/importing-files).
 * > - Any interruption in the upload process stops the file upload. For files larger than 10MB, or when network connection is poor, use `generateFileResumableUploadUrl()` instead. With the resumable upload URL, any interruption in the upload process pauses the file upload, and resumes the file upload process after the interruption.
 * @param mimeType - File mime type.
 * @public
 * @requiredField mimeType
 * @param options - Options to use when generating a file's upload URL.
 * @adminMethod
 */
export function generateFileUploadUrl(mimeType, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            mimeType: '$[0]',
            fileName: '$[1].fileName',
            sizeInBytes: '$[1].sizeInBytes',
            parentFolderId: '$[1].parentFolderId',
            private: '$[1].private',
            labels: '$[1].labels',
            externalInfo: '$[1].externalInfo',
            rawNamespace: '$[1].rawNamespace',
            namespace: '$[1].namespace',
            filePath: '$[1].filePath',
            internalTags: '$[1].internalTags',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateFileUploadUrlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateFileUploadUrlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([mimeType, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.generateFileUploadUrl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'mimeType',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Generates a resumable upload URL to allow external clients to upload large files over 10MB to the Media Manager.
 *
 * The `generateFileResumableUploadUrl()` function returns a Promise that resolves to an upload URL, token, and protocol.
 *
 * When using the resumable upload URL, any interruptions will pause the file upload process, which automatically resumes once the interruption is resolved. The resumable upload URL is also helpful when network connection is poor.
 *
 * To learn how external clients can use the generated upload URL in the response to upload large files to the Media Manager, see the Resumable Upload API article.
 *
 * > **Note:** When you upload a file, it's not immediately available, meaning you can't manage or use the file straight away. Learn more about [knowing when a file is ready](/files/importing-files).
 * @param mimeType - File mime type.
 * @public
 * @requiredField mimeType
 * @param options - Options to use when generating a resumable upload URL.
 * @adminMethod
 */
export function generateFileResumableUploadUrl(mimeType, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            mimeType: '$[0]',
            fileName: '$[1].fileName',
            sizeInBytes: '$[1].sizeInBytes',
            parentFolderId: '$[1].parentFolderId',
            private: '$[1].private',
            labels: '$[1].labels',
            uploadProtocol: '$[1].uploadProtocol',
            rawNamespace: '$[1].rawNamespace',
            namespace: '$[1].namespace',
            filePath: '$[1].filePath',
            internalTags: '$[1].internalTags',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateFileResumableUploadUrlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateFileResumableUploadUrlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([mimeType, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.generateFileResumableUploadUrl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'mimeType',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Imports a file to the Media Manager using an external URL.
 *
 * The `importFile()` function returns a Promise that resolves to the imported file's descriptor.
 *
 * This function returns information about the imported file. Importing a file is the method through which you can add files to the Media Manager.
 * Use the `parentFolderId` and `filePath` parameters to specify which folder you want the file to be imported to.
 * If no folder is specified, the file is imported to the `media-root` folder.
 *
 * > **Note:** When you import a file, it's not immediately available, meaning you can't manage or use the file straight away. Learn more about [knowing when a file is ready](/files/importing-files).
 *
 * To import a file, you need to do one of the following:
 * - Pass its [MIME type](https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types) in the `mimeType` field of the request. For example, `mimeType: 'image/jpeg'`.
 * - Include its extension in either the `displayName` or `url` field of the request. For example, `displayName: 'Example Image.jpeg` or `url: https://www.example.com/image.jpeg`.
 * - Ensure the server hosting the file supports HEAD requests. In these cases the Wix servers can retrieve the MIME type from the hosting server.
 *   > **Note:** If you want to validate the media type, pass the file's expected media type in the optional `mediaType` field of the request.  For example, `mediaType: 'IMAGE'`.
 * @param url - Publicly accessible external file URL.
 * @public
 * @requiredField url
 * @param options - Options to use when importing a single file.
 * @adminMethod
 */
export function importFile(url, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            url: '$[0]',
            mediaType: '$[1].mediaType',
            displayName: '$[1].displayName',
            parentFolderId: '$[1].parentFolderId',
            private: '$[1].private',
            labels: '$[1].labels',
            mimeType: '$[1].mimeType',
            externalInfo: '$[1].externalInfo',
            urlParams: '$[1].urlParams',
            urlHeaders: '$[1].urlHeaders',
            rawNamespace: '$[1].rawNamespace',
            namespace: '$[1].namespace',
            filePath: '$[1].filePath',
            internalTags: '$[1].internalTags',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _importFileRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _importFileResponse,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['file']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([url, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.importFile(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'url',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * > **Deprecated.**
 * > This function has been replaced with `bulkImportFile()`, and will be removed on March 31, 2024.
 *
 *
 * The `bulkImportFiles()` function returns a Promise that resolves to an array of the imported files' descriptors.
 *
 * Imports a bulk of files to the Media Manager using external urls.
 *
 * Returns information about the imported files. Use the `parentFolderId` and `filePath` parameters to specify in which folder you want each file to be imported.
 * If no folder is specified, the file is imported to the `media-root` folder.
 *
 * >**Note:** The `media` property isn't returned in the `files` response object.
 *
 * To import files, you need to do one of the following for each file:
 * - Pass its [MIME type](https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types) in the `mimeType` field of the request. For example, `mimeType: 'image/jpeg'`.
 * - Include its extension in either the `displayName` or `url` field of the request. For example, `displayName: 'Example Image.jpeg` or `url: https://www.example.com/image.jpeg`.
 * - Ensure the server hosting the file supports HEAD requests. In these cases the Wix servers can retrieve the MIME type from the hosting server.
 *   > **Note:** If you want to validate the media type, pass the file's expected media type in the optional `mediaType` field of the request.  For example, `mediaType: 'IMAGE'`.
 * @param importFileRequests - Information about the files to import.
 * @public
 * @requiredField importFileRequests
 * @requiredField importFileRequests.url
 * @param options - Options to use when uploading multiple files.
 * @adminMethod
 * @deprecated
 * @replacedBy com.wix.media.site_media.v1.FilesService.BulkImportFile
 * @targetRemovalDate 2024-03-31
 */
export function bulkImportFiles(importFileRequests) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { importFileRequests: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkImportFilesRequest,
            depSchemas: { _importFileRequest },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkImportFilesResponse,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['Array#files']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([importFileRequests]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.bulkImportFiles(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'importFileRequests',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Imports a bulk of files to the Media Manager using external urls.
 *
 * The `bulkImportFile()` function returns a Promise that resolves to an object containing bulk import metadata and an array of imported files' descriptors and metadata.
 *
 * Returns information about the imported files. Use the `parentFolderId` and `filePath` parameters to specify in which folder you want each file to be imported.
 * If no folder is specified, the file is imported to the `media-root` folder.
 *
 * > **Note:** When you import a file, it's not immediately available, meaning you can't manage or use the file straight away. Learn more about [knowing when a file is ready](/files/importing-files).
 *
 * To import files, you need to do one of the following for each file:
 * - Pass its [MIME type](https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types) in the `mimeType` field of the request. For example, `mimeType: 'image/jpeg'`.
 * - Include its extension in either the `displayName` or `url` field of the request. For example, `displayName: 'Example Image.jpeg` or `url: https://www.example.com/image.jpeg`.
 * - Ensure the server hosting the file supports HEAD requests. In these cases the Wix servers can retrieve the MIME type from the hosting server.
 *   > **Note:** If you want to validate the media type, pass the file's expected media type in the optional `mediaType` field of the request.  For example, `mediaType: 'IMAGE'`.
 * @param importFileRequests - Information about the files to import.
 * @public
 * @requiredField importFileRequests
 * @requiredField importFileRequests.url
 * @param options - Options to include the file descriptor in the response.
 * @adminMethod
 */
export function bulkImportFile(importFileRequests, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            importFileRequests: '$[0]',
            returnEntity: '$[1].returnEntity',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkImportFileRequest,
            depSchemas: { _importFileRequest },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkImportFileResponse,
            depSchemas: {
                _audioV2,
                _bulkImportFileResult,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['Array#results.item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([importFileRequests, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.bulkImportFile(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'importFileRequests',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of files in the Media Manager.
 *
 * The `listFiles()` function returns a Promise that resolves to an array of the specified files' descriptors and cursor information.
 *
 * To retrieve a list of files within a specific folder in the Media Manager, pass the folder's ID in the `parentFolderId` parameter. If no folder is specified, the function retrieves only the files in the root folder of the Media Manager.
 *
 * To retrieve a list of (non-permanently) deleted files, use the `listDeletedFiles()` function.
 * @public
 * @param options - Options to use when listing media files.
 * @adminMethod
 */
export function listFiles(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            parentFolderId: '$[0].parentFolderId',
            mediaTypes: '$[0].mediaTypes',
            private: '$[0].private',
            sort: '$[0].sort',
            paging: '$[0].paging',
            rawNamespace: '$[0].rawNamespace',
            namespace: '$[0].namespace',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listFilesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listFilesResponse,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['Array#files']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.listFiles(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Searches all folders in the Media Manager and returns a list of files that match the terms specified in the optional parameters.
 *
 * The `searchFiles()` function returns a Promise that resolves to an array of the specified files' descriptors and cursor information.
 *
 * If no parameters are specified, the function returns all files in the `MEDIA_ROOT` folder.
 * @public
 * @param options - Options to specify which folders to search.
 * @adminMethod
 */
export function searchFiles(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            search: '$[0].search',
            rootFolder: '$[0].rootFolder',
            mediaTypes: '$[0].mediaTypes',
            private: '$[0].private',
            sort: '$[0].sort',
            paging: '$[0].paging',
            internalTag: '$[0].internalTag',
            rawNamespace: '$[0].rawNamespace',
            namespace: '$[0].namespace',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _searchFilesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _searchFilesResponse,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['Array#files']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.searchFiles(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Generates a URL for streaming a specific video file in the Media Manager.
 *
 *
 * The `generateVideoStreamingUrl()` function returns a Promise that resolves to a download URL and its asset key.
 *
 * To stream different assets of the file, use the `assetKeys` parameter which generates a video streaming URL for each asset. If no asset key is specified, it defaults to `src`, which generates one video streaming URL in the original file's format and quality.
 * @public
 * @requiredField fileId
 * @param options - Options to use when generating a video file's streaming URL.
 * @param fileId - File ID.
 *
 * You can also pass the files' Wix media URLs. For example, `["wix:image://v1/0abec0_b291a9349a0b4da59067f76287e386fb~mv2.jpg/leon.jpg#originWidth=3024&originHeight=4032"]`.
 * Learn more in the File and Folder IDs article.
 * @adminMethod
 */
export function generateVideoStreamingUrl(fileId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fileId: '$[0]', format: '$[1].format' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateVideoStreamingUrlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateVideoStreamingUrlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fileId, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.generateVideoStreamingUrl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fileId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Return a token for a direct web socket notification channel
 * This API is not platformized (Contact the Media team for use instructions)
 * This API should be internal only
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function generateWebSocketToken() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateWebSocketTokenRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateWebSocketTokenResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.generateWebSocketToken(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes the specified files from the Media Manager.
 *
 *
 * The `bulkDeleteFiles()` function returns a Promise that resolves when the files are deleted.
 *
 * The deleted files are moved to the Media Manager's trash bin (`TRASH_ROOT` folder) unless permanently deleted. To permanently delete files, pass the `permanent` parameter with the value `true`. Permanently deleting files isn't reversible, so make sure that these files aren't being used in a site or in any other way as the files will no longer be accessible.
 *
 * >**Notes:**
 * > - The specified files can be from different folders.
 * > - Moving multiple files at once is an asynchronous action, and may take time for the changes to appear in the Media Manager.
 * > - Attempting to delete files that are already in the trash bin doesn't result in an error.
 * > - If your site contains deleted media files, the deleted media files still appear on your site as the files are still in the Media Manager (in the trash bin).
 * > - You can use `bulkRestoreFilesFromTrashBin()` to restore files from the Media Manager's trash bin.
 * @public
 * @requiredField fileIds
 * @param options - Options to use when deleting files.
 * @param fileIds - IDs of the files to move to the Media Manager's trash bin.
 *
 * You can also pass the files' Wix media URLs. For example, `["wix:image://v1/0abec0_b291a9349a0b4da59067f76287e386fb~mv2.jpg/leon.jpg#originWidth=3024&originHeight=4032"]`.
 * Learn more in the File and Folder IDs article.
 * @adminMethod
 */
export function bulkDeleteFiles(fileIds, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            fileIds: '$[0]',
            permanent: '$[1].permanent',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkDeleteFilesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkDeleteFilesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fileIds, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.bulkDeleteFiles(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fileIds',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Restores the specified files from the Media Manager's trash bin, and moves them to their original locations in the Media Manager.
 *
 * The `bulkRestoreFilesFromTrashBin()` function returns a Promise that resolves when the files have been restored.
 * @public
 * @requiredField fileIds
 * @param fileIds - IDs of the files to restore from the Media Manager's trash bin.
 *
 * You can also pass the files' Wix media URLs. For example, `["wix:image://v1/0abec0_b291a9349a0b4da59067f76287e386fb~mv2.jpg/leon.jpg#originWidth=3024&originHeight=4032"]`.
 * Learn more in the File and Folder IDs article.
 * @adminMethod
 */
export function bulkRestoreFilesFromTrashBin(fileIds) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fileIds: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkRestoreFilesFromTrashBinRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkRestoreFilesFromTrashBinResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fileIds]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.bulkRestoreFilesFromTrashBin(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fileIds',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of files in the Media Manager's trash bin.
 *
 * The `listDeletedFiles()` function returns a Promise that resolves to an array of the specified deleted files' descriptors and cursor information.
 *
 * >**Note:** The Media Manager's trash bin (`TRASH_ROOT` folder) only contains temporarily deleted files, not permanently deleted files.
 *
 * To retrieve a list of non-deleted files, use the `listFiles()` function.
 * @public
 * @param options - Options to use when listing deleted files from the trash bin.
 * @adminMethod
 */
export function listDeletedFiles(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            parentFolderId: '$[0].parentFolderId',
            mediaTypes: '$[0].mediaTypes',
            private: '$[0].private',
            sort: '$[0].sort',
            paging: '$[0].paging',
            rawNamespace: '$[0].rawNamespace',
            namespace: '$[0].namespace',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listDeletedFilesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listDeletedFilesResponse,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['Array#files']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.listDeletedFiles(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a file by the specified ID.
 *
 * You can use the `parentFolderId` parameter to move a file from its current folder to a different folder.
 * @internal
 * @requiredField fileId
 * @param options - Fields to update.
 * @param fileId - ID of the file to update.
 *
 * You can also pass the files' Wix media URLs. For example, `["wix:image://v1/0abec0_b291a9349a0b4da59067f76287e386fb~mv2.jpg/leon.jpg#originWidth=3024&originHeight=4032"]`.
 * Learn more in the File and Folder IDs article.
 * @adminMethod
 * @deprecated method is deprecated due to standard aligning
 * @replacedBy com.wix.media.site_media.v1.filesService.UpdateFileDescriptor
 * @targetRemovalDate 2023-03-31
 */
export function updateFile(fileId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            fileId: '$[0]',
            displayName: '$[1].displayName',
            parentFolderId: '$[1].parentFolderId',
            labels: '$[1].labels',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateFileRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateFileResponse,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [...['file']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fileId, options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1FileDescriptor.updateFile(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fileId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=media-site-media-v1-file-descriptor.universal.js.map